// we don't use an object to prevent to expose all origin paths, better for tree shaking
export const ORIGIN_UAT_API = 'https://dev-mtm.isaiastore.com/api';
export const ORIGIN_UAT_APP = 'https://dev-mtm.isaiastore.com';

export const ORIGIN_PROD_API = 'https://mtm.isaia.it/api';
export const ORIGIN_PROD_APP = 'https://mtm.isaia.it';

export const ORIGIN_LOCAL_API = 'https://api-mtm.isaia.lan/api';
export const ORIGIN_LOCAL_APP = 'http://localhost:4200';

export const ORIGIN_LAN_API = 'https://api-mtm.isaia.lan/api';
export const ORIGIN_LAN_APP = 'https://api-mtm.isaia.lan';

export const ORIGIN_V2_API = 'https://v2-api-mtm.isaiastore.com/api';
// One host for the app and the API, like every other environment. Two reasons it
// had to move off Vercel: that domain is not reachable from inside ISAIA, and
// Microsoft sign-in redirects to the app origin — so serving the app from the
// isaiastore host while the redirect pointed at Vercel meant sign-in could never
// complete there.
export const ORIGIN_V2_APP = 'https://mtm-v2.isaia-tools.it';
